import React from 'react';
import { ResponsiveLine } from '@nivo/line';
import { TIME_DURATION } from '../../constants';
import { ALL_MONTHS } from '../../staticData';

const getXAxisLabel = (data, durationText) => {
  const { value } = data;
  let labelData = value.split(' ');
  if (durationText === TIME_DURATION.LAST_SEVEN_DAYS) {
    const date = labelData[0];
    const month = labelData[1];
    return renderXAxisLabel(data, date, month);
  } else if (
    durationText === TIME_DURATION.LAST_FOUR_WEEKS ||
    durationText === TIME_DURATION.LAST_SIX_MONTHS
  ) {
    let datesInARange = labelData[0].split('-');
    if (parseInt(datesInARange[0]) < parseInt(datesInARange[1])) {
      return renderXAxisLabel(data, labelData[0], labelData[1]);
    } else {
      const month = labelData[1];
      const startDateLabel =
        datesInARange[0] + ' ' + getPreviousMothName(month) + ' -';
      const endDateLabel = datesInARange[1] + ' ' + month + '  ';
      return renderXAxisLabel(data, startDateLabel, endDateLabel);
    }
  }
};

const renderXAxisLabel = (data, firstLabel, secondLabel) => {
  const { opacity, textAnchor, textBaseline, textX, textY, x, y } = data;
  return (
    <g transform={`translate(${x + 2},${y + 4})`} style={{ opacity }}>
      <text
        alignmentBaseline={textBaseline}
        textAnchor={textAnchor}
        transform={`translate(${textX},${textY})`}
      >
        <tspan style={{ display: 'block', fontSize: '10px' }}>
          {firstLabel}
        </tspan>
      </text>
      <text
        alignmentBaseline={textBaseline}
        textAnchor={textAnchor}
        transform={`translate(${textX},${textY + 10})`}
      >
        <tspan style={{ display: 'block', fontSize: '10px' }}>
          {secondLabel}
        </tspan>
      </text>
    </g>
  );
};

const getPreviousMothName = month => {
  let counter = 0;
  for (; counter < ALL_MONTHS.length; counter++) {
    if (ALL_MONTHS[counter] === month) {
      break;
    }
  }
  if (counter === 0) {
    return ALL_MONTHS[ALL_MONTHS.length - 1];
  } else {
    return ALL_MONTHS[counter - 1];
  }
};
const MultiLineGraph = ({ data, maxRecordCount, durationText, label }) => {
  return (
    <ResponsiveLine
      lineWidth={2}
      data={data}
      margin={{ top: 50, right: 150, bottom: 50, left: 60 }}
      colors={['#8BBFFF', '#144F98', '#7EC3A7', '#4A806A', '#F17C7C']}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 0,
        max: maxRecordCount,
        stacked: false,
        reverse: false,
      }}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: 'bottom',
        tickSize: 0,
        tickPadding: 20,
        tickRotation: 0,
        renderTick: data => {
          return getXAxisLabel(data, durationText);
        },
      }}
      axisLeft={{
        orient: 'left',
        tickSize: 0,
        tickPadding: 20,
        tickRotation: 0,
        legend: label,
        legendOffset: -50,
        legendPosition: 'middle',
      }}
      enableGridX={false}
      pointSize={6}
      pointColor={{ from: 'color', modifiers: [] }}
      pointBorderWidth={2}
      pointBorderColor={{ from: 'serieColor' }}
      pointLabel="y"
      pointLabelYOffset={-12}
      enableSlices="x"
      useMesh={true}
      activePointBorderWidth={3}
      legends={[
        {
          anchor: 'right',
          direction: 'column',
          justify: false,
          translateX: 90,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: 'left-to-right',
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: 'square',
          symbolBorderColor: 'rgba(0, 0, 0, .5)',
          effects: [
            {
              on: 'hover',
              style: {
                itemBackground: 'rgba(0, 0, 0, .03)',
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

export default MultiLineGraph;
